import React from 'react';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { VectorMap } from '@south-paw/react-vector-maps';
import world from '../../common/world.svg.json';
import USAMap from '../../assets/images/USAMap.png'
const SalesByLocations = (props) => {
    console.log("SalesByLocations",props)
    return (
        <React.Fragment>
            <Col xl={4}>
                <Card className="card-height-100">
                    <CardHeader className="align-items-center d-flex">
                        <h4 className="card-title mb-0 flex-grow-1">Top 3 Sales by Locations</h4>
                        {/* <div className="flex-shrink-0">
                            <button type="button" className="btn btn-soft-primary btn-sm">
                                Export Report
                            </button>
                        </div> */}
                    </CardHeader>

                    <CardBody>

                        <div
                            data-colors='["--vz-light", "--vz-secondary", "--vz-primary"]'
                            style={{ height: "269px" }} dir="ltr">
                            <div id="world_map_line_markers" className="custom-vector-map">
                                {/* <VectorMap {...world} /> */}
                                <img src={USAMap} className="img-fluid d-block"/>
                            </div>
                        </div>

                        <div className="px-2 py-2 mt-1">
                        {(props.data || []).map((item, index) => (<div key={index}>
                                <p className="mt-3 mb-1">{item.city} <span className="float-end">{item.percentage}%</span></p>
                                <div className="progress mt-2" style={{ height: "6px" }}>
                                    <div className="progress-bar progress-bar-striped bg-primary" role="progressbar"
                                        style={{ width: item.percentage }} aria-valuenow={item.percentage} aria-valuemin="0" aria-valuemax={item.percentage}>
                                    </div>
                                </div>
                            </div>))} 
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default SalesByLocations;